<template>
<aside :class="['mdc-snackbar', error && 'error']">
    <div
        class="mdc-snackbar__surface"
        role="status">
        <div
            ref="label"
            class="mdc-snackbar__label"
            aria-live="polite"></div>
    </div>
</aside>
</template>

<script>
import { MDCSnackbar, strings, numbers } from "@material/snackbar";
export default {
    props: {
        options: { type: Object, default: () => null }
    },
    data: () => ({
        instance: null,
        currentOption: null,
        queue: [],
        isOpen: false
    }),
    computed: {
        ...["error", "message"].reduce((result, key) => {
            result[key] = {
                get() {
                    const { currentOption } = this;
                    return currentOption && currentOption[key];
                }
            };
            return result;
        }, {})
    },
    watch: {
        options(value) {
            if (this.isOpen) {
                if (value.direct) {
                    this.instance.close();
                    this.queue.splice(0, 0, value);
                } else {
                    this.queue.push(value);
                }
            } else {
                this.currentOption = value;
            }
        },
        currentOption({
            message,
            timeoutMs = numbers.MIN_AUTO_DISMISS_TIMEOUT_MS,
            closeOnEscape
        } = {}) {
            if (!message) return;

            const {
                instance,
                $refs: { label }
            } = this;
            instance.labelText = null;
            instance.timeoutMs = timeoutMs;
            instance.closeOnEscape = closeOnEscape;
            instance.open();
            label.innerHTML = message;
        }
    },
    mounted() {
        const snackbar = new MDCSnackbar(this.$el);
        snackbar.listen(strings.OPENING_EVENT, () => {
            this.isOpen = true;
        });
        snackbar.listen(strings.CLOSED_EVENT, () => {
            this.isOpen = false;
            if (this.queue.length) {
                this.currentOption = this.queue.shift();
            }
        });
        this.instance = snackbar;
        if (this.options) {
            this.currentOption = this.options;
        }
    }
};
</script>
